import React , { useState} from "react";
import { Link } from "react-router-dom";
//import { Dropdown, DropdownMenu, DropdownToggle, Form } from "reactstrap";

//import images
import logoBig from "../assets/images/logo_big.png";
import logoSmall from "../assets/images/logo_small.svg";
import creamIcon from "../assets/images/chat-smile-ai-line.svg";
//import mlogoBig from "../assets/images/mlogo_big.svg";
import {Comm} from "../script/cpmComm";

//import Components
//import SearchOption from "../Components/Common/bootstrap/SearchOption";
//import LanguageDropdown from "../Components/Common/bootstrap/LanguageDropdown";
//import WebAppsDropdown from "../Components/Common/bootstrap/WebAppsDropdown";
//import NotificationDropdown from "../Components/Common/bootstrap/NotificationDropdown";
//import LightDark from "../Components/Common/bootstrap/LightDark";

import FullScreenDropdown from "../Components/Common/bootstrap/FullScreenDropdown";

import { changeSidebarVisibility } from "../store/actions";
import { useSelector, useDispatch } from "react-redux";
//import useDidMountEffect from "../script/useDidMountEffect";

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
  const [userInfo, setUserInfo] = useState({
      userId     : sessionStorage.getItem("userId")
    , userNm     : sessionStorage.getItem("userNm")
    , compNm     : sessionStorage.getItem("agncyNm")
    , compTypeCd : sessionStorage.getItem("compTypeCd")
  });

  /*
  const [search, setSearch] = useState(false);
  const toogleSearch = () => {
    setSearch(!search);
  };
   */

  const dispatch = useDispatch();
  const { sidebarVisibilitytype } = useSelector((state) => ({
    sidebarVisibilitytype: state.Layout.sidebarVisibilitytype,
  }));

  const toogleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;
    dispatch(changeSidebarVisibility("show"));
    if (windowSize > 767)
      document.querySelector(".hamburger-icon").classList.toggle("open");
    //For collapse horizontal menu
    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body.classList.contains("menu")
        ? document.body.classList.remove("menu")
        : document.body.classList.add("menu");
    }
    //For collapse vertical and semibox menu
    if (
      sidebarVisibilitytype === "show" &&
      (document.documentElement.getAttribute("data-layout") === "vertical" ||
        document.documentElement.getAttribute("data-layout") === "semibox")
    ) {
      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "sm"
          ? document.documentElement.setAttribute("data-sidebar-size", "")
          : document.documentElement.setAttribute("data-sidebar-size", "sm");
      } else if (windowSize > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "lg"
          ? document.documentElement.setAttribute("data-sidebar-size", "sm")
          : document.documentElement.setAttribute("data-sidebar-size", "lg");
      } else if (windowSize <= 767) {
        document.body.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    }
    //Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel")
        ? document.body.classList.remove("twocolumn-panel")
        : document.body.classList.add("twocolumn-panel");
    }
  };

  return (
    <React.Fragment>
      <header id="page-topbar"   className={headerClass} style={{zIndex: 1006}}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logoSmall} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoBig} alt="" height="30" />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoSmall} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoBig} alt="" height="30" />
                  </span>
                </Link>
              </div>

              <button
                onClick={toogleMenuBtn}
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
            </div>

            <div className="d-flex align-items-center">
              {/*
              {((window.location.href).indexOf("stg-z.") > 0 ) &&
                  (
                      <div className="text-bold fs-16">~~~~~~~~~~~~~~~여기는 개발서버요~~~~~~~~~~~~~~~~ </div>
                  )
              }*/}
              <FullScreenDropdown />
              {userInfo.compTypeCd === 'SAA01' && (
                <div className="dropdown topbar-head-dropdown ms-1 header-item">
                  <button
                    type="button"
                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle btn-animated"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasCreamCpm"
                    aria-controls="offcanvasCreamCpm"
                    title="Cream+AI"
                  >
                    <img src={creamIcon} alt="Cream+AI" width="22" height="22" className="ai-icon-svg" />
                  </button>
                </div>
              )}
              <div  type="button" className="ms-1 header-item d-none d-sm-flex bg-soft-info pe-3" onClick={Comm.goMethodia }>
                <button
                    type="button"
                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                    title={'메소디아 바로가기'}
                >
                  <img src={logoSmall} alt="" height="22" />
                </button>
                메소디아 바로가기
              </div>
              <span   className="ms-sm-3 header-item topbar-user">
                  <span className="d-flex align-items-center" >
                      <span className="text-center " style={{width: '150px'}}>
                          <span className=" d-xl-inline-block ms-1 fw-medium user-name-text">{userInfo.userNm}({userInfo.userId})</span>
                          <span className="d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{userInfo.compNm}</span>
                      </span>
                  </span>
              </span>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
